import * as action from './actions';

export const getSocialConfig = () => {
  return {
    type: action.GET_SOCIAL_CONFIG,
    payload: {},
  };
};

export const saveSocialConfig = (configs, updatedBy) => {
  return {
    type: action.SAVE_SOCIAL_CONFIG,
    payload: {
      configs,
      updatedBy,
    },
  };
};

export const getVendorSocialContent = (vendorId, contentType) => {
  return {
    type: action.GET_VENDOR_SOCIAL_CONTENT,
    payload: {
      vendorId,
      contentType,
    },
  };
};

export const getVendorSocialPosts = (vendorId) => {
  return {
    type: action.GET_VENDOR_SOCIAL_POSTS,
    payload: {
      vendorId,
    },
  };
};

export const createVendorSocialPost = (bundle) => {
  return {
    type: action.CREATE_VENDOR_SOCIAL_POST,
    payload: bundle,
  };
};

export const updateVendorSocialPost = (bundle) => {
  return {
    type: action.UPDATE_VENDOR_SOCIAL_POST,
    payload: bundle,
  };
};

export const deleteVendorSocialPost = (vendorId, postId) => {
  return {
    type: action.DELETE_VENDOR_SOCIAL_POST,
    payload: {
      vendorId,
      postId,
    },
  };
};

export const pushVendorSocialPostNow = (bundle) => {
  return {
    type: action.PUSH_VENDOR_SOCIAL_POST_NOW,
    payload: bundle,
  };
};

const ACTION_HANDLERS = {
  [action.SET_SOCIAL_CONFIG]: (state, actions) => {
    return { ...state, ...actions.payload };
  },
  [action.SET_VENDOR_SOCIAL_CONTENT]: (state, actions) => {
    return { ...state, ...actions.payload };
  },
  [action.SET_VENDOR_SOCIAL_POSTS]: (state, actions) => {
    return { ...state, ...actions.payload };
  },
  [action.SET_SOCIAL_STATUS]: (state, actions) => {
    return { ...state, ...actions.payload };
  },
};

let defaultState = {
  platforms: [],
  vendorContent: [],
  vendorContentType: 'promotion',
  posts: [],
  loadingConfig: false,
  loadingContent: false,
  loadingPosts: false,
  saving: false,
  saveSuccess: false,
  error: null,
};

export const reducer = (state = defaultState, actions) => {
  const handler = ACTION_HANDLERS[actions.type];
  return handler ? handler(state, actions) : state;
};
